/*
 * @FilePath: /mall-fe/src/views/web/home/index.tsx
 * @Description: cscec3b 商城首页门户入口页面
 *
 */
import { toProps as toBrandPicsProps } from 'comps/BrandPics';
// import Footer from 'comps/Footer';
import Header from 'comps/Header';
// import HomeBannerNew from 'comps/HomeBannerNew';
// import HomeHireBanner from 'comps/HomeHireBanner';
// import HomeCategoryFloor from 'comps/HomeCategoryFloor';
// import HomeHotFloor from 'comps/HomeHotFloor';
// import HomeMaterialPrice from 'comps/HomeMaterialPrice';
import Layout from 'comps/Layout';
// import SectorEntry from 'comps/SectorEntry';
// import SmartRecommend from 'comps/SmartRecommend';
import useUrl from 'hooks/useUrl';
import { SiteContext } from 'libs/contexts';
// import { CurrentUserTypeSource, UserSource } from 'libs/enums';
import { useContext } from 'react';
import NewIndex from 'views/web/home/NewIndex';
// import HomeInnovative from 'comps/HomeInnovative';
// import ProjectNewAddCard from '@/biz-components/web/ProjectNewAddCard';
// import FactoryDirect from 'views/web/home/NewIndex/components/FactoryDirect';
// import HomeAdvert from 'comps/HomeAdvert';

/**
 *
 * @param {object} floorsData 楼层数据
 * @param {object} bannersData 广告位数据
 * @param {object} brandsData 品牌数据
 * @param {object} skuStatisticsData 商品统计数据
 * @param {object} hotData 热点商品数据
 * @param {object} recommendData 推荐商品数据
 * @param {object} bulletinData 公共数据
 * @param {object} categorys 商品分类
 * @param {object} newIndexFloorsData 楼层商品数据
 * @param {object} newIndexRecommendData 首次推荐商品数
 * @param {object} newIndexHotData 首层热点商品
 * @param {object} newIndexBannerData 首页品牌数据
 * @param {object} newIndexBulletinData 公共信息
 * @param {object} hireBannerData 雇佣广告数据
 * @param {object} outwardHireBannerData 外租广告位
 * @param {object} projectNewAddListData 新开项目列表
 * @param {object} factoryDirectListData 厂家直采列表
 * @returns
 */
const Index = ({
  floorsData,
  bannersData,
  brandsData,
  skuStatisticsData,
  hotData,
  recommendData,
  bulletinData,
  categorys,
  // newIndexFloorsData,
  // newIndexRecommendData,
  // newIndexHotData,
  // newIndexBannerData,
  // newIndexBulletinData,
  hireBannerData,
  // outwardHireBannerData,
  projectNewAddListData,
  factoryDirectListData,
}: any) => {
  const site = useContext(SiteContext);
  // const userInfo = useContext(UserContext);
  const { getPublicUrl } = useUrl();
  // const isNewHome =
  //   !userInfo ||
  //   userInfo?.organizationSource === UserSource.outside ||
  //   userInfo.currentUserType === CurrentUserTypeSource.personal;
  /**
   * PC端首页依据「是否内部用户」区分，使用「NewIndex」或者「老首页」
   */
  return (
    <>
      {/* <HomeAdvert /> */}
      <Layout
        header={<Header showCategory />}
        footer={null}
        keywords="数字化,供应链管理,数字采购,供应链金融"
        description={`${
          site?.basic?.tenantName || ''
        }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
        showFixedMenu
        bgColor="#ffffff"
      >
        {/* {isNewHome ? ( */}
        <NewIndex
          {...{
            bannersData: bannersData,
            bulletinData: bulletinData,
            categorys,
            skuStatisticsData,
            newIndexRecommendData: recommendData,
            newIndexHotData: hotData,
            floorsData: floorsData,
            brands: toBrandPicsProps(brandsData, getPublicUrl),
            outwardHireBannerData: hireBannerData,
            projectNewAddListData,
            factoryDirectListData,
          }}
        />
        {/* ) : (
          <>
            <HomeBannerNew
              banners={bannersData}
              bulletinData={bulletinData}
              categorys={categorys}
            />
            {hireBannerData?.length > 0 && <HomeHireBanner banners={hireBannerData} />}
            <HomeInnovative />
            {!!factoryDirectListData?.length && (
              <FactoryDirect
                floorData={{
                  title: '厂家直采',
                  children: factoryDirectListData,
                }}
              />
            )}
            {!!projectNewAddListData?.datas?.length && (
              <ProjectNewAddCard projectList={projectNewAddListData.datas} />
            )}
            {site?.mall?.enableSelfSiteMode === SITE_MODE.SHOP && (
              <SmartRecommend
                recommendData={recommendData}
                projectNewAddListData={projectNewAddListData}
              />
            )}
            <HomeHotFloor hotData={hotData} />
            {floorsData.map((floor) => (
              <HomeCategoryFloor key={floor.id} floorData={floor} />
            ))}
            <SectorEntry />
            <HomeMaterialPrice skuStatisticsData={skuStatisticsData} />
            <BrandPics brands={toBrandPicsProps(brandsData, getPublicUrl)} title="第三方电商平台" />
          </>
        )} */}
      </Layout>
    </>
  );
};

export default Index;
